import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

interface ToasterComponentProps {
  position?: ToasterProps["position"];
  visibleToasts?: number;
  duration?: number;
}

function Toaster({
  position = "bottom-right",
  visibleToasts = 5,
  duration = 4000,
  ...props
}: ToasterComponentProps) {
  return (
    <SonnerToaster
      position={position}
      visibleToasts={visibleToasts}
      duration={duration}
      toastOptions={{
        classNames: {
          toast:
            "bg-background text-foreground border-border shadow-lg rounded-md",
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}
Toaster.displayName = "Toaster";

export { Toaster };
